module.exports = __webpack_public_path__ + "static/media/Sports_BG.20bdbc7b.jpg";